











import {Component, Vue} from 'vue-property-decorator';
import AppHeader from './components/AppHeader.vue';
import ToastMessage from './components/ToastMessage.vue';
import {mapState} from 'vuex';
import {debounce} from 'lodash';

@Component({
  metaInfo(this: any) {
    return {
      title: this.$t('meta.title'),
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
    };
  },
  components: {
    AppHeader,
    ToastMessage,
  },
  computed: mapState(['toast', 'partner']),
})

export default class App extends Vue {
  public partner!: any;

  public handleResize() {
    this.$store.commit('setWindowWidth', window.innerWidth);
  }

  private created() {
    window.addEventListener('resize', debounce(() => {
      this.handleResize();
    }, 100));
    this.handleResize();

    if (this.$gtm.dataLayer() ) {
      this.$gtm.dataLayer().push({
        website_code: 'BB8',
        language: this.$i18n.locale,
        partner: this.partner.externalId,
      });
    }
  }

  private beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
}
